import { PropsWithChildren } from 'react';
import { PostHogProvider } from 'posthog-js/react';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AuthProvider } from './AuthContext';
import { InvitesProvider } from './InvitesContext';
import { TripsProvider } from './TripsContext';
import { ExpensesProvider } from './ExpensesContext';
import { BudgetProvider } from './BudgetContext';
import { RefundReportProvider } from './RefundReportContext';
import { ConversionProvider } from './ConversionContext';

export const RootProvider = ({ children }: PropsWithChildren): React.ReactNode => {
  return (
    <AuthProvider>
      <PostHogProvider
        apiKey={process.env.REACT_APP_POSTHOG_KEY!}
        options={{
          api_host: process.env.REACT_APP_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: process.env.NODE_ENV === 'development',
        }}
      >
        <InvitesProvider>
          <TripsProvider>
            <ConversionProvider>
              <ExpensesProvider>
                <BudgetProvider>
                  <RefundReportProvider>
                    <TooltipProvider>
                      {children}
                    </TooltipProvider>
                  </RefundReportProvider>
                </BudgetProvider>
              </ExpensesProvider>
            </ConversionProvider>
          </TripsProvider>
        </InvitesProvider>
      </PostHogProvider>
    </AuthProvider>
  );
};
